<div class="mb-10">
  <h1 class="text-3xl uppercase !leading-snug md:text-4xl">{{ this.title_key | translate }}</h1>
  <!--<p class="text-base font-bold leading-normal text-white-dark">{{ 'form_label_login_description' | translate }}</p>-->
</div>

@if (loginMode === 'biometric') {
<div class="flex flex-col items-center gap-3 py-10 dark:text-white">
  <button
    type="button"
    (click)="loginWithBiometrics()"
    [disabled]="biometricLoading"
    class="flex h-24 w-24 items-center justify-center rounded-full border-2 border-primary bg-primary/5 text-primary shadow-[0_10px_24px_-8px_rgba(67,97,238,0.55)] transition hover:scale-105 hover:bg-primary/10 disabled:opacity-60"
    aria-label="Log in with fingerprint"
  >
    <i class="fa-solid fa-fingerprint text-5xl"></i>
  </button>
  <p class="font-semibold">{{ biometricLoading ? 'Verifying...' : 'Tap to log in with fingerprint' }}</p>
  @if (biometricEmail) {
  <p class="text-sm text-white-dark">{{ biometricEmail }}</p>
  }
  <button type="button" (click)="switchToPasswordLogin()" class="mt-6 text-sm font-semibold text-primary underline">Use email &amp; password instead</button>
</div>
}

@if (loginMode === 'password') {
<form class="space-y-5 dark:text-white" [formGroup]="loginForm" (ngSubmit)="onSubmit()" autocomplete="off">
  <div class="login-form">
    <label for="Email">{{ 'form_label_email' | translate }}</label>
    <div class="relative text-white-dark">
      <input
        formControlName="email"
        id="Email"
        type="email"
        placeholder="{{ 'form_label_email_placeholder' | translate }}"
        class="form-input ps-10 placeholder:text-white-dark"
        [class.is-invalid]="isSubmitted && loginForm.controls['email'].invalid"
      />
      <span class="absolute start-4 top-1/2 -translate-y-1/2">
        <i class="fa-solid fa-envelope"></i>
      </span>
    </div>
    @if (isSubmitted && loginForm.controls['email'].hasError('pattern')) {
    <div class="text-danger">
      {{ 'form_email_valid_msg' | translate }}
    </div>
    } @if (isSubmitted && loginForm.controls['email'].hasError('required')) {
    <div class="text-danger">
      {{ 'form_email_req_msg' | translate }}
    </div>
    } @if (isSubmitted && loginForm.controls['email'].hasError('email')) {
    <div class="text-danger">{{ 'form_email_valid_msg' | translate }}</div>
    }
  </div>
  <div class="login-form">
    <label for="Password">{{ 'form_label_password' | translate }}</label>
    <div class="relative text-white-dark">
      <input
        autocomplete="new-password"
        formControlName="password"
        id="Password"
        [type]="passwordVisible ? 'text' : 'password'"
        placeholder="{{ 'form_label_password_placeholder' | translate }}"
        class="form-input ps-10 placeholder:text-white-dark"
        [class.is-invalid]="isSubmitted && loginForm.controls['password'].invalid"
      />
      <span class="absolute start-4 top-1/2 -translate-y-1/2">
        <i class="fa-solid fa-unlock-keyhole"></i>
      </span>
      <span
        class="absolute end-4 top-1/2 -translate-y-1/2 cursor-pointer"
        (click)="togglePasswordVisibility(); toggleIcon()"
        [ngClass]="{ 'text-dark': iconClicked, 'text-light': !iconClicked }"
      >
        <i class="fa-regular fa-eye"></i>
      </span>
    </div>
    @if (isSubmitted && passwordControl?.invalid) {
    <div class="text-danger">{{ 'form_email_req_pwd' | translate }}</div>
    }
  </div>
  <div class="login-form flex items-center justify-between">
    <label class="flex cursor-pointer items-center">
      <input formControlName="subscribe" type="checkbox" class="form-checkbox bg-white dark:bg-black" />
      <span class="text-white-dark">{{ 'form_remember_me' | translate }}</span>
    </label>
    <a routerLink="/forget-password" class="text-white-dark hover:text-blue-500">
      {{ 'forget_pwd' | translate }}
    </a>
  </div>
  <button type="submit" class="btn btn-primary login-form !mt-6 w-full border-0 uppercase shadow-[0_10px_20px_-10px_rgba(67,97,238,0.44)]" [disabled]="loading">
    {{ 'submit' | translate }}
  </button>

  @if (showBiometricLogin) {
  <div class="!mt-4 text-center">
    <button type="button" (click)="switchToBiometricLogin()" class="text-sm font-semibold text-primary underline">
      <i class="fa-solid fa-fingerprint"></i>&nbsp; Use fingerprint instead
    </button>
  </div>
  }
</form>
}
<!--<div class="relative my-7 text-center md:mb-9">
    <span class="absolute inset-x-0 top-1/2 h-px w-full -translate-y-1/2 bg-white-light dark:bg-white-dark"></span>
    <span class="relative bg-white px-2 font-bold uppercase text-white-dark dark:bg-dark dark:text-white-light">or</span>
  </div>-->
<!--<div class="mb-10 md:mb-[60px]">
  <ul class="flex justify-center gap-3.5 text-white">
    <li>
      <a
        href="javascript:"
        class="inline-flex h-8 w-8 items-center justify-center rounded-full p-0 transition hover:scale-110"
        style="background: linear-gradient(135deg, rgba(239, 18, 98, 1) 0%, rgba(67, 97, 238, 1) 100%)"
        >
        <icon-instagram />
      </a>
    </li>
    <li>
      <a
        href="javascript:"
        class="inline-flex h-8 w-8 items-center justify-center rounded-full p-0 transition hover:scale-110"
        style="background: linear-gradient(135deg, rgba(239, 18, 98, 1) 0%, rgba(67, 97, 238, 1) 100%)"
        >
        <icon-facebook-circle />
      </a>
    </li>
    <li>
      <a
        href="javascript:"
        class="inline-flex h-8 w-8 items-center justify-center rounded-full p-0 transition hover:scale-110"
        style="background: linear-gradient(135deg, rgba(239, 18, 98, 1) 0%, rgba(67, 97, 238, 1) 100%)"
        >
        <icon-twitter [fill]="true" />
      </a>
    </li>
    <li>
      <a
        href="javascript:"
        class="inline-flex h-8 w-8 items-center justify-center rounded-full p-0 transition hover:scale-110"
        style="background: linear-gradient(135deg, rgba(239, 18, 98, 1) 0%, rgba(67, 97, 238, 1) 100%)"
        >
        <icon-google />
      </a>
    </li>
  </ul>
</div>-->
@if (showTenantRegistration) {
<div class="mt-5 text-center dark:text-white">
  Don't have an account?
  <a routerLink="/tenant/registration" class="uppercase text-primary underline transition hover:text-black dark:hover:text-white"> Register As Tenant </a>
</div>
}
